import './forms.css'
import React from 'react'
import { map, isEmpty } from 'lodash'
import { db } from '../services/firebase'
import { Field, reduxForm } from 'redux-form'
import { FormGroup, Row, Col } from 'react-bootstrap'
import Button from 'elements/CustomButton/CustomButton.jsx'
import { renderField, renderSelect } from './_fieldRenderer'

class StockProductForm extends React.Component {

    state = {
        currentItems: [],
        selectedItem: null,
        mappingFabrics: false
    }

    render() {
        const { currentItems, selectedItem, mappingFabrics } = this.state
        const { handleSubmit, submitting, products, change } = this.props

        return (
            <form onSubmit={handleSubmit}>
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <Field
                                name='model'
                                component={renderSelect}
                                options={this._prepareProductsOptions(products)}
                                label='Modelo'
                                placeholder='Selecione'
                                onChange={((e, newValue) => {
                                    const currentItems = []
                                    change('item', null)
                                    change('composition', null)
                                    change('quantity', null)
                                    change('discount', null)
                                    this.setState({ currentItems })
                                    map(products, product => {
                                        if (newValue && newValue.value && product.id === newValue.value) {
                                            map(product.variants, variant => {
                                                map(variant.items, item => currentItems.push({
                                                    value: item.id,
                                                    label: `${item.name} - ${item.description}`,
                                                    composition: item.composition,
                                                    fabricLines: item.fabricLines,
                                                    variant: variant.id,
                                                    coverImageURL: product.coverImageURL,
                                                    productLine: product.productLine
                                                }))
                                            })
                                            this.setState({ currentItems })
                                        }
                                    })
                                })}
                            />
                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <Field
                                name='item'
                                component={renderSelect}
                                options={currentItems}
                                label='Item'
                                placeholder='Selecione'
                                disabled={!currentItems.length}
                                onChange={((e, newValue) => {
                                    this.setState({ selectedItem: newValue })
                                    change('composition', null)
                                    change('quantity', null)
                                    change('discount', null)
                                })}
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    {
                        selectedItem && !isEmpty(selectedItem.composition) && map(selectedItem.composition, comp => (
                            <Col md={6} key={comp.id}>
                                <FormGroup>
                                    <Field
                                        name={`composition[${comp.id}]`}
                                        component={renderSelect}
                                        label={`${comp.description} - ${comp.percentage}%`}
                                        placeholder='Selecione'
                                        disabled={mappingFabrics}
                                        options={this._mapFabrics(comp.percentage)}
                                        validate={this._validateComposition}
                                    />
                                </FormGroup>
                            </Col>
                        ))
                    }

                    {selectedItem && isEmpty(selectedItem.composition) && (
                        <Col md={6}>
                            <FormGroup>
                                <Field
                                    name='composition'
                                    component={renderSelect}
                                    label='ÚNICA - 100%'
                                    placeholder='Selecione'
                                    disabled={mappingFabrics}
                                    options={this._mapFabrics(100)}
                                    validate={this._validateComposition}
                                />
                            </FormGroup>
                        </Col>
                    )}

                    <Col md={3}>
                        <FormGroup>
                            <Field
                                name='quantity'
                                type='number'
                                component={renderField}
                                label='Quantidade'
                                placeholder='Quantidade'
                            />
                        </FormGroup>
                    </Col>

                    <Col md={3}>
                        <FormGroup>
                            <Field
                                name='discount'
                                type='number'
                                component={renderField}
                                label='Desconto (%)'
                                placeholder='Desconto (%)'
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col md={6} sm={12} xs={12}>
                        <Button
                            style={{ width: '100%', marginTop: 10 }}
                            bsStyle='danger'
                            type='button'
                            disabled={submitting}
                            onClick={this._handleCancel}
                            wd
                        >
                            Cancelar
                         </Button>
                    </Col>
                    <Col md={6} sm={12} xs={12}>
                        <Button
                            style={{ width: '100%', marginTop: 10 }}
                            bsStyle='default'
                            type='submit'
                            disabled={submitting}
                            fill
                        >
                            Salvar
                         </Button>
                    </Col>
                </Row>
            </form >
        )
    }

    _handleCancel = _ => {
        this.props.reset() //form reset - redux-form action creator
        this.props.handleCancel() //function passed via props
    }

    _prepareProductsOptions = products => {
        const output = []
        map(products, product => output.push({ label: product.model, value: product.id }))
        return output
    }

    _validateComposition = (value, allValues, props) => {
        if (!value) return 'Obrigatório'
    }

    _mapFabrics = percentage => {
        const { selectedItem } = this.state

        const ref = db.collection('fabrics')
        const fabrics = []

        if (selectedItem && selectedItem.fabricLines) {

            map(selectedItem.fabricLines, async line => {
                let data = await ref.where('fabricLine', '==', line.fx).get()
                if (!data.empty) {
                    data.forEach(d => fabrics.push({
                        ...d.data(),
                        id: d.id,
                        fabricLineName: line.name,
                        fx: line.fx,
                        value: line.value, // prop to select
                        percentage,
                        percentagePrice: `R$ ${(parseFloat(line.value).toFixed(2) * (Number(percentage) / 100)).toFixed(2).replace('.', ',')}`,
                        label: `${d.data().name} - R$ ${(parseFloat(line.value).toFixed(2) * (Number(percentage) / 100)).toFixed(2).replace('.', ',')}` // prop to select
                    }))
                }

            })
            return fabrics
        }
        return []
    }

}

const validate = values => {
    const errors = {}
    if (!values.model) { errors.model = 'Obrigatório' }
    if (!values.item) { errors.item = 'Obrigatório' }
    if (!values.quantity) { errors.quantity = 'Obrigatório' }
    if (!values.discount) { errors.discount = 'Obrigatório' }

    return errors
}

StockProductForm = reduxForm({ form: 'StockProductForm', validate })(StockProductForm)
export default StockProductForm



// WEBPACK FOOTER //
// ./src/forms/StockProductForm.jsx